export default __webpack_public_path__ + "assets/product-overview-video-3-thumbnail-new.png";